// ── Condutor ──────────────────────────────────────────────────────────────

export interface Condutor {
  id: number;
  nome: string;
  cpf: string;
  cnh?: string;
  categoriaCnh?: string;
  dtValidadeCnh?: string;
  rg?: string;
  telefone?: string;
  ativo: boolean;
}

export interface CondutorCombo {
  id: number;
  nome: string;
  cpf: string;
}

export interface SalvarCondutorRequest {
  nome: string;
  cpf: string;
  cnh?: string;
  categoriaCnh?: string;
  dtValidadeCnh?: string;
  rg?: string;
  telefone?: string;
  ativo: boolean;
}

// ── Reboque ───────────────────────────────────────────────────────────────

export interface Reboque {
  id: number;
  placa: string;
  uf: string;
  renavam?: string;
  capacidadeM3?: number;
  capacidadeKg?: number;
  taraKg?: number;
  tipoCarroceria?: string;
  ativo: boolean;
}

export interface ReboqueCombo {
  id: number;
  placa: string;
  uf: string;
}

export interface SalvarReboqueRequest {
  placa: string;
  uf: string;
  renavam?: string;
  capacidadeM3?: number;
  capacidadeKg?: number;
  taraKg?: number;
  tipoCarroceria?: string;
  ativo: boolean;
}

export const TIPOS_CARROCERIA = [
  "aberta",
  "fechada",
  "graneleira",
  "portacontainer",
  "sider",
  "basculante",
] as const;

export const CATEGORIAS_CNH = ["A", "B", "AB", "C", "D", "E"] as const;
